module.exports = [{
      plugin: require('../../../plugins/gatsby-powergo-brp-smartsite-theme/gatsby-browser.js'),
      options: {"plugins":[],"instockToken":"55c636bd431c63b1f029b58a18704ccde1f18dc6","sourceEnv":"production","websiteDomain":"www.groupeimperium.ca"},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
